export const PreferenceConvertor: any = (pref: any[]) =>
  pref.map((item: any) => {
    let temp: any = null;
    try {
      temp = JSON.parse(item.value);
    } catch {
      temp = item.value;
    }
    return { ...item, value: temp };
  });
